/**
 * Entrada por el portal de Nitria (SSO de la marca Nitrofert, decidido 2026-09-30). El portal es la única
 * entrada normal: abre la app en {@link PORTAL_NITRIA_RUTA_SSO} con un token, y sin sesión válida la app
 * redirige a su login. Lo usan `BaseInit` (arranque) y `GrpcTransport` (sesión rechazada con la app abierta).
 */
import { secureStorage } from "../modulos/seguridad/login/services/SecureStorageService";

/** Ruta fija con la que el portal abre la app (`/auth/verify-acount?token=JWT`). La define la guía del
 *  portal ("soil-apps-external-sso-integration"), con esa ortografía, y no se puede cambiar. */
export const PORTAL_NITRIA_RUTA_SSO: string = "/auth/verify-acount";

/** Texto del botón que lleva al login del portal. */
export const PORTAL_NITRIA_BOTON: string = "Ir al portal Nitria";

/** La ruta del portal llegó sin token: mismo texto que el servidor usa para un token inválido. */
export const PORTAL_NITRIA_SIN_TOKEN_MESSAGE: string =
  "No se pudo validar tu acceso desde el portal Nitria. Vuelve al portal e ingresa de nuevo.";

/** Falla de red al entrar desde el portal: hay que pedir un enlace nuevo. */
export const PORTAL_NITRIA_SIN_CONEXION_MESSAGE: string =
  "No hay conexión con el servidor. Revisa tu internet y vuelve a ingresar desde el portal.";

/** Falla de red al abrir la app con la sesión guardada: se puede reintentar. */
export const PORTAL_NITRIA_REINTENTAR_MESSAGE: string =
  "No hay conexión con el servidor. Revisa tu internet e intenta de nuevo.";

/** Botón de la pantalla de acceso: texto y acción. */
export type AccionAccesoPortal = {
  /** Texto del botón. */
  texto: string;
  /** Qué hace al tocarlo. */
  onClick: () => void;
};

/** Evita redirigir dos veces cuando varias llamadas fallan juntas. */
let _redirigiendo = false;

/** Borra la sesión guardada y manda al login del portal. Reemplaza la página en el historial, así el
 *  botón atrás del navegador no vuelve a una app vacía. Varias llamadas seguidas redirigen una sola vez. */
export function fx_irAlPortalNitria(portalLoginUrl: string): void {
  if (_redirigiendo) return;
  _redirigiendo = true;
  secureStorage.remove().finally(() => window.location.replace(portalLoginUrl));
}

/** Pinta en `contenedor` la pantalla de acceso: logo, motivo por el que no se pudo ingresar y un botón.
 *  El motivo va como texto, nunca como HTML: puede traer el email del token. */
export function fx_renderAccesoPortal(
  contenedor: HTMLElement,
  logoRoute: string,
  mensaje: string,
  accion: AccionAccesoPortal,
): void {
  contenedor.removeAttribute("id");
  contenedor.className = "sx-acceso-portal";

  const logo = document.createElement("img");
  logo.src = logoRoute;
  logo.alt = "";

  const texto = document.createElement("p");
  texto.className = "sx-acceso-portal-mensaje";
  texto.setAttribute("role", "alert");
  texto.textContent = mensaje;

  const boton = document.createElement("button");
  boton.type = "button";
  boton.className = "sx-btn sx-btn-primary";
  boton.textContent = accion.texto;
  boton.addEventListener("click", accion.onClick);

  contenedor.replaceChildren(logo, texto, boton);
}
